export default __webpack_public_path__ + "static/media/jac-logo-small.6933ef47.png";